import React from 'react'
import styled from 'styled-components'
import { financeColors, financeRadius } from '../tokens'
import { FinanceCardTone } from '../types'

interface Props {
  tone: Exclude<FinanceCardTone, 'default'> | 'default'
  title?: React.ReactNode
  message: React.ReactNode
  actions?: React.ReactNode
}

const palette = {
  default: [
    financeColors.surfaceAlt,
    financeColors.border,
    financeColors.textSoft,
  ],
  info: [financeColors.infoBg, financeColors.infoBorder, '#1d4ed8'],
  success: [financeColors.successBg, financeColors.successBorder, '#127a46'],
  warning: [financeColors.warningBg, financeColors.warningBorder, '#9a6700'],
  danger: [financeColors.dangerBg, financeColors.dangerBorder, '#991b1b'],
} as const

const Wrap = styled.div<{ $tone: keyof typeof palette }>`
  padding: 12px 14px;
  border-radius: ${financeRadius.sm};
  border: 1px solid ${(props) => palette[props.$tone][1]};
  background: ${(props) => palette[props.$tone][0]};
  color: ${(props) => palette[props.$tone][2]};
  display: grid;
  gap: 8px;
`

const Title = styled.div`
  font-size: 13px;
  font-weight: 700;
`

const Message = styled.div`
  font-size: 13px;
  line-height: 1.5;
`

const FinanceInlineAlert: React.FC<Props> = ({
  tone,
  title,
  message,
  actions,
}) => (
  <Wrap $tone={tone}>
    {title && <Title>{title}</Title>}
    <Message>{message}</Message>
    {actions}
  </Wrap>
)

export default FinanceInlineAlert
